const Header = () => {
   return (
      <div className="header">
         <h1>About</h1>
         <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum,
            aperiam!
         </p>
      </div>
   );
};
export default Header;
